import { defineStore } from 'pinia'
import { services } from '@/assets/js/config.js';
import { useHttpStore } from './httpStore';
import { useCustomerStore } from './customerStore';
import { useCommonStore } from '@/stores/commonStore';

export const useLoanCaseStore = defineStore('loancase', {
  state: () => ({
    activeCase: {},
		activeCollections:[],
		activeRedemptions:[],
		activeDisbursements:[],
		activeStatements:[],
		activeRepayments:[],
		activeUnpaidRepayments:[],
		activePaidRepayments:[],
		activeRemarks:[],
  }),
  getters: {
    
  },
  actions: {
		clearCaseState(){
			this.activeCase = {}
			this.activeCollections = []
			this.activeRedemptions = []
			this.activeDisbursements = []
			this.activeStatements = []
			this.activeRepayments = []
			this.activeUnpaidRepayments = []
			this.activeRemarks = []
		},
		/**
		 * CASE
		 */
    getCaseList(params,fetchCustomer=false) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.get(`${services.invinity}loan-case`, params).then((resp) => {
          httpStore.convertPaginationKeys(resp.data);

          resolve(resp.data);
        }).catch(err => {
          _gNotif.cLog(err);
          reject(err);
        });
      });
    },
    getCase(case_id = null) {
      const httpStore = useHttpStore();
			if(_gHlp.isEmpty(case_id)){
				case_id = _gHlp.getValue(this.activeCase,'case_id')
			}
			return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					httpStore.get(`${services.invinity}loan-case/${case_id}`).then((resp) => {
						this.activeCase = resp.data.data;
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },
		updateCase(params, case_id = null) {
      const httpStore = useHttpStore();
			if(_gHlp.isEmpty(case_id)){
				case_id = _gHlp.getValue(this.activeCase,'case_id')
			}
			return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					httpStore.put(`${services.invinity}loan-case/${case_id}`, params).then((resp) => {
						this.getCase(case_id)
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },

		/**
		 * SETTLEMENT
		 */
    getSettlementsList(params) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.get(`${services.invinity}loan-settlement`, params).then((resp) => {
          httpStore.convertPaginationKeys(resp.data);
          resolve(resp.data);
        }).catch(err => {
          _gNotif.cLog(err);
          reject(err);
        });
      });
    },

    createOrUpdateSettlement(params) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        if (params.id) {
          httpStore.put(`${services.invinity}loan-settlement/${params.id}`, params).then((resp) => {
            resolve(resp.data);
          }).catch(err => {
            _gNotif.cLog(err);
            reject(err);
          });
        } else {
          httpStore.post(`${services.invinity}loan-settlement`, params).then((resp) => {
            resolve(resp.data);
          }).catch(err => {
            _gNotif.cLog(err);
            reject(err);
          });
        }
      });
    },

    deleteSettlement(id) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.delete(`${services.invinity}loan-settlement/${id}`).then((resp) => {
          resolve(resp.data);
        }).catch(err => {
          _gNotif.cLog(err);
          reject(err);
        });
      });
    },

		/**
		 * DISBURSEMENT
		 */
    getDisbList(case_id=null, params = {}) {
      const httpStore = useHttpStore();
			if(_gHlp.isEmpty(case_id)){
				case_id = _gHlp.getValue(this.activeCase,'case_id')
			}
      return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					params['paginate'] = 'no_paginate';
					httpStore.get(`${services.invinity}loan-case/${case_id}/disb`, params).then((resp) => {
						httpStore.convertPaginationKeys(resp.data);
						this.activeDisbursements = resp.data.data;
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },

    createDisb(params) {
      const httpStore = useHttpStore();
			let case_id = _gHlp.getValue(this.activeCase,'case_id')
      return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					httpStore.post(`${services.invinity}loan-case/${case_id}/disb`, params).then((resp) => {
						resolve(resp.data.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },

    updateDisb(id, params, case_id = null) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					case_id = _gHlp.getValue(this.activeCase,'case_id')
				}
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					httpStore.put(`${services.invinity}loan-case/${case_id}/disb/${id}`, params).then((resp) => {
						resolve(resp.data.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },

    bulkUpdateDisb(params, case_id = null) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					case_id = _gHlp.getValue(this.activeCase,'case_id')
				}
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					httpStore.put(`${services.invinity}loan-case/${case_id}/disb-bulk-update`, params).then((resp) => {
						resolve(resp.data.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },

    deleteDisb(id) {
      const httpStore = useHttpStore();
			let case_id = _gHlp.getValue(this.activeCase,'case_id')
      return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					httpStore.delete(`${services.invinity}loan-case/${case_id}/disb/${id}`).then((resp) => {
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },

		/**
		 * COLLECTION 
		 */
		getCollList(params = undefined) {
      const httpStore = useHttpStore();
			let case_id = _gHlp.getValue(this.activeCase,'case_id')
      return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					httpStore.get(`${services.invinity}loan-case/${case_id}/coll`, params).then((resp) => {
						httpStore.convertPaginationKeys(resp.data);
						this.activeCollections = resp.data.data;
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },

    createColl(params) {
      const httpStore = useHttpStore();
			let case_id = _gHlp.getValue(this.activeCase,'case_id')
      return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					httpStore.post(`${services.invinity}loan-case/${case_id}/coll`, params).then((resp) => {
						resolve(resp.data.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },

    updateColl(id, params) {
      const httpStore = useHttpStore();
			let case_id = _gHlp.getValue(this.activeCase,'case_id')
      return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					httpStore.put(`${services.invinity}loan-case/${case_id}/coll/${id}`, params).then((resp) => {
						resolve(resp.data.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },

    deleteColl(id) {
      const httpStore = useHttpStore();
			let case_id = _gHlp.getValue(this.activeCase,'case_id')
      return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					httpStore.delete(`${services.invinity}loan-case/${case_id}/coll/${id}`).then((resp) => {
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },

		/**
		 * REPAYMENTS
		 */
		getRepayList(params={}) {
      const httpStore = useHttpStore();
			let case_id = _gHlp.getValue(this.activeCase,'case_id')
      return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					httpStore.get(`${services.invinity}loan-case/${case_id}/repay`, params).then((resp) => {
						this.activeRepayments = _gHlp.getValue(resp,'data',[]);
						this.activeUnpaidRepayments = this.activeRepayments.filter(itm => _gHlp.isEmpty(itm.paid_status));
						this.activePaidRepayments = this.activeRepayments.filter(itm => !_gHlp.isEmpty(itm.paid_status));
						resolve(this.activeRepayments);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },

		/**
		 * STATEMENT 
		 * */
		checkStatementList(case_id){
			return new Promise((resolve, reject) => {
				this.updateCase({recalculate: 'checking'},case_id).then((resp) => {
					resolve(resp);
				}).catch((err) => {
					reject(err);
				})
			});
		},
		getStatementList(params) {
      const httpStore = useHttpStore();
			let case_id = _gHlp.getValue(this.activeCase,'case_id')
      return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					httpStore.get(`${services.invinity}loan-case/${case_id}/statement`, params).then((resp) => {
						httpStore.convertPaginationKeys(resp.data);
						this.activeStatements = _gHlp.getValue(resp,'data.data',[]);
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },

		/**
		 * REDEMPTION 
		 */
		getRedemList(params = undefined) {
      const httpStore = useHttpStore();
			let case_id = _gHlp.getValue(this.activeCase,'case_id')
      return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					httpStore.get(`${services.invinity}loan-case/${case_id}/redem`, params).then((resp) => {
						httpStore.convertPaginationKeys(resp.data);
						this.activeRedemptions = resp.data.data;
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },

    createRedem(params) {
      const httpStore = useHttpStore();
			let case_id = _gHlp.getValue(this.activeCase,'case_id')
      return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					httpStore.post(`${services.invinity}loan-case/${case_id}/redem`, params).then((resp) => {
						this.getRedemList({ paginate: 'no_paginate' }).then(ret => {
							resolve(resp.data);
						})
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },

    updateRedem(id, params) {
      const httpStore = useHttpStore();
			let case_id = _gHlp.getValue(this.activeCase,'case_id')
      return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					httpStore.put(`${services.invinity}loan-case/${case_id}/redem/${id}`, params).then((resp) => {
						this.getRedemList({ paginate: 'no_paginate' }).then(ret => {
							resolve(resp.data);
						})
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },

    deleteRedem(id) {
      const httpStore = useHttpStore();
			let case_id = _gHlp.getValue(this.activeCase,'case_id')
      return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					httpStore.delete(`${services.invinity}loan-case/${case_id}/redem/${id}`).then((resp) => {
						this.getRedemList({ paginate: 'no_paginate' }).then(ret => {
							resolve(resp.data);
						})
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },

		/**
		 * Remarks 
		 */
		getRemarkList(params) {
			const httpStore = useHttpStore();
			let case_id = _gHlp.getValue(this.activeCase,'case_id')
      return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					httpStore.get(`${services.invinity}loan-case/${case_id}/remark`, params).then((resp) => {
						httpStore.convertPaginationKeys(resp.data);
						this.activeRemarks = _gHlp.getValue(resp,'data.data',[]);
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },

    createRemark(params) {
      const httpStore = useHttpStore();
			let case_id = _gHlp.getValue(this.activeCase,'case_id')
      return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					httpStore.post(`${services.invinity}loan-case/${case_id}/remark`, params).then((resp) => {
						this.getRemarkList({paginate:'no_paginate'}).then(ret => {
							resolve(resp.data);
						})
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },

    updateRemark(id, params) {
      const httpStore = useHttpStore();
			let case_id = _gHlp.getValue(this.activeCase,'case_id')
      return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					httpStore.put(`${services.invinity}loan-case/${case_id}/remark/${id}`, params).then((resp) => {
						this.getRemarkList({paginate:'no_paginate'}).then(ret => {
							resolve(resp.data);
						})
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },

    deleteRemark(id) {
      const httpStore = useHttpStore();
			let case_id = _gHlp.getValue(this.activeCase,'case_id')
      return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(case_id)){
					reject(false);
				}else{
					httpStore.delete(`${services.invinity}loan-case/${case_id}/remark/${id}`).then((resp) => {
						this.getRemarkList({paginate:'no_paginate'}).then(ret => {
							resolve(resp.data);
						})
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}
      });
    },
  }
})